// extracted by mini-css-extract-plugin
module.exports = {"note":"note___3QBH6","yunxin-whiteboard":"yunxin-whiteboard___sUV3m","left":"left___1b-tc"};